import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateCapacityAssessmentRating } from "common/services/capacity-assessments.service";
import Form from "./Form";
import { toast } from "react-toastify";

const UpdateCapacityAssessmentRating: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);
  // validation

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: selectedRecord?.name,
      capacityAssessmentType: {
        value: selectedRecord?.capacityAssessmentType?.id,
        label: selectedRecord?.capacityAssessmentType?.name,
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
      capacityAssessmentType: Yup.object().shape({
        value: Yup.number().required("Please select type of assessment"),
      }),
    }),
    onSubmit: async (values: any) => {
      const data = {
        id: selectedRecord?.id,
        data: {
          name: values["name"],
          capacityAssessmentType: values.capacityAssessmentType.value,
        },
      };

      setLoading(true);
      try {
        await updateCapacityAssessmentRating(data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Capacity assessment rating updated successfully", {});
      } catch (e: any) {
        toast.error("Capacity assessment rating update failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Capacity Assessment Rating
      </ModalHeader>

      <Form
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default UpdateCapacityAssessmentRating;
